/**
 * useCommandPalette
 *
 * Module-level singleton state for the command palette. The CommandPalette
 * component is mounted once in App.vue; callers (keyboard shortcuts, menu
 * items, etc.) toggle `isOpen` via open()/close() from anywhere.
 */
import { ref } from "vue"

const isOpen = ref(false)

export function useCommandPalette() {
  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return { isOpen, open, close }
}
